module.exports = __webpack_public_path__ + "static/img/logo_nueva.71ca3b73.png";